import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';

import { noop } from 'ui-components/default-props/noop';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Button } from 'ui-components/components/button';

import style from './style.module.less';
import sharedStyle from '../style.module.less';

const SuccessFragment = () => (
  <React.Fragment>
    <div className={style.header}>
      <FontAwesomeIcon className={style['success-icon']} icon={faCheck} />
      <div className={sharedStyle['title-text']}>
        <FormattedMessage defaultMessage='Verification Successful!' description='phoneVerifyModal.verificationSuccessTitle' id='uvM6SG' />
      </div>
    </div>
    <div className={sharedStyle['subtitle-text']}>
      <FormattedMessage
        defaultMessage='2 step authentication verified!'
        description='phoneVerifyModal.verificationSuccessSubtitle'
        id='KTse/Q'
      />
    </div>
  </React.Fragment>
);

const FailureFragment = () => (
  <React.Fragment>
    <div className={style.header}>
      <FontAwesomeIcon className={style['failure-icon']} icon={faXmark} />
      <div className={sharedStyle['title-text']}>
        <FormattedMessage defaultMessage='Verification Failed' description='phoneVerifyModal.verificationFailureTitle' id='5bhQLh' />
      </div>
    </div>
    <div className={classnames(sharedStyle['subtitle-text'], style.failed)}>
      {/* TODO: this number is bs */}
      <FormattedMessage defaultMessage='Authentication Failed.' description='phoneVerifyModal.verificationFailedSubtitle' id='e4XpSL' />
      <FormattedMessage
        defaultMessage='Please call Stamps.com (866) 634-4708.'
        description='phoneVerifyModal.pleaseCallStamps'
        id='X68H+M'
      />
    </div>
  </React.Fragment>
);

const VerificationResults = ({ isVerified = false, closeModal = noop, className = '' }) => (
  <React.Fragment>
    <ModalBody className={classnames(style.wrapper, className)}>
      {isVerified && <SuccessFragment />}
      {!isVerified && <FailureFragment />}
    </ModalBody>
    <ModalFooter className={sharedStyle.footer}>
      <Button className={style['ok-button']} onClick={closeModal} theme='primary'>
        <FormattedMessage defaultMessage='Ok' description='phoneVerifyModal.okButton' id='h+yQZX' />
      </Button>
    </ModalFooter>
  </React.Fragment>
);

VerificationResults.propTypes = {
  className: PropTypes.string,
  isVerified: PropTypes.bool,
  closeModal: PropTypes.func,
};

export default VerificationResults;
